import { arrayToObject } from 'utils';
import {
  asianHandicapMarketsUOF,
  handicapMarketsUOF, nextGoalUOF,
  restOfTheMatchMarketsUOF,
  specialMarketsUOF,
  totalMarketsUOF,
  whoScoresPointUOF,
  winGamesUOF,
  winTennisSetUOF,
  raceToPointsUOF,
  winTennisGameUOF,
} from 'constants/enum';


export const updateMatchInfoState = (state, payload) => {
  if (!payload) {
    return state;
  }
  const matchIds = Object.keys(payload.entities.match);
  if (matchIds.length > 0) {
    const matchId = matchIds[0];
    const { events, match, ...matchinfo } = payload.entities.match[matchId];

    return {
      ...state,
      matchInfo: {
        ...state.matchInfo,
        [matchId]: {
          ...state.matchInfo[matchId],
          ...matchinfo,
          round: match.round,
          roundname: match.roundname,
        },
      },

      match: {
        ...state.match,
        [matchId]: {
          ...state.match[matchId],
          ...match,
          overtimeperiods: match.overtimeperiods,
        },
      },
    };
  } else {
    return state;
  }
};

export const updateJerseysInfoState = (state, payload) => {
  if (!payload) {
    return state;
  }
  const matchIds = Object.keys(payload.entities.match);
  if (matchIds.length > 0) {
    const matchId = matchIds[0];
    const { events, match, ...matchinfo } = payload.entities.match[matchId];

    return {
      ...state,
      matchInfo: {
        ...state.matchInfo,
        [matchId]: {
          ...state.matchInfo[matchId],
          jerseys: matchinfo.jerseys,
        },
      },
    };
  } else {
    return state;
  }
};

// goes through a match and concats every oddsIdByMarket, then concats each match's
const getAllOddsIds = newMatches => (
  Object.values(newMatches).reduce(
    (prevMatch, curMatch) => prevMatch.concat(
      Object.values(curMatch.oddsIdsByMarket).reduce(
        (prevMarket, curMarket) => prevMarket.concat(curMarket), [],
      ),
    ), [],
  ));

const getAllMarketIds = (newBigMarket, payload, matchId) => {
  // remove ids with substring matchId
  const allMarketIds = Object.keys(newBigMarket).filter(bg => !bg.includes(matchId));

  const curMarketIds = Object.values(payload.matches).reduce(
    (prev, cur) => prev.concat(Object.keys(cur.oddsIdsByMarket).map(marketId => matchId + '_' + marketId)),
    [],
  );
    // add back this match's marketids from payload
  return allMarketIds.concat(curMarketIds);
};

// only include markets where extra is used for marketname
const getExtras = filteredMarkets => Object.values(filteredMarkets)
  .reduce((accumulator, cur) => {
    const oddsMarketId = cur.id.split('_')[1];
    if (specialMarketsUOF.includes(oddsMarketId)) {
      accumulator[cur.id] = cur.extra;
    } else {
      accumulator[cur.id] = null;
    }

    return accumulator;
  }, {});

export const updateClientMatchId = (state, payload) => {
  if (!payload || !payload.doc || !payload.doc.length) {
    return state;
  }

  const newClientMatchIds = { ...state.clientMatchIds };

  if (payload.doc[0].data && payload.doc[0].data.mappings) {
    payload.doc[0].data.mappings.forEach(mapping => {
      const { _matchid, externalid } = mapping;
      newClientMatchIds[_matchid] = externalid; // Add [_matchid]: externalid
    });
  }

  return {
    ...state,
    clientMatchIds: newClientMatchIds,
  };
};
export const updateMatchMarkets = (state, payload) => {
  if (!payload || !Object.keys(payload.matches).length) {
    return state;
  }
  const matchId = Object.keys(payload.matches)[0];

  const newOdds = {
    ...state.markets.odds,
    ...payload.odds,
  };

  const newMatches = {
    ...state.markets.matches,
    [matchId]: { ...payload.matches[matchId] },
  };

  const newBigMarket = {
    ...state.markets.bigMarket,
    ...payload.bigMarket,
  };

  const newMLT = {
    ...state.markets.marketLookup,
    ...payload.marketLookupTable,
  };

  const newClientMatchIds = {
    ...state.clientMatchIds,
    ...payload.clientMatchId,
  };

  let marketLookupTable;
  const mltKeys = Object.keys(newMLT);
  const mltKeysOld = Object.keys(state.markets.marketLookup);
  // replace if arrays are not equal
  if (mltKeys.length === mltKeysOld.length && mltKeys.every(key => mltKeysOld.includes(key))) {
    marketLookupTable = state.markets.marketLookup;
  } else {
    marketLookupTable = newMLT;
  }

  const allMarketIds = getAllMarketIds(newBigMarket, payload, matchId);
  const allOddsIds = getAllOddsIds(newMatches);

  const filteredOdds = arrayToObject(
    Object.values(newOdds).filter(o => allOddsIds.includes(o.tbid)),
    'tbid',
  );
  const filteredMarkets = arrayToObject(
    Object.values(newBigMarket).filter(mm => allMarketIds.includes(mm.id)),
    'id',
  );
  const extras = getExtras(filteredMarkets);


  return {
    ...state,

    markets: {
      matches: {
        ...newMatches,
      },
      odds: {
        ...filteredOdds,
      },
      bigMarket: {
        ...filteredMarkets,
      },
      extras: {
        ...extras,
      },
      marketLookup: marketLookupTable,
    },
    clientMatchIds: {
      ...newClientMatchIds,
    },
  };
};

/*
The `tbid` in the Redux store is connected through the `markets.odds` structure.
Specifically, the `tbid` serves as the key in the `odds` object, which is derived from the `arrayToObject` function.
This function filters odds based on `allOddsIds` and maps them into an object where each `tbid` is the key.

Relevant Structure:
1. `markets.odds`:
   - Contains odds objects keyed by `tbid`.
   - Example: `{ tbid1: oddsObject1, tbid2: oddsObject2, ... }`.

2. `getAllOddsIds`:
   - Aggregates all `tbid` values from `oddsIdsByMarket` across matches and markets.

3. `updateMatchMarkets`:
   - Filters odds using `allOddsIds` and maps them into the `markets.odds` structure.
*/

/**
 * Generates a unique identifier for an outcome within a market and match.
 *
 * @param {string} matchId - The unique identifier for the match.
 * @param {string} marketId - The unique identifier for the market.
 * @param {string} outcomeId - The unique identifier for the outcome, prefixed with 'sr:outcome:'.
 * @returns {string} - Concatenated string combining matchId, marketId, and the outcomeId without 'sr:outcome:' prefix.
 */
export const getOutcomeMarketMappingTbid = (matchId, marketId, outcomeId) => `${matchId}${marketId}${outcomeId.replace('sr:outcome:', '')}`;

export const isMarketInCollection = (collection, marketId) => collection.includes(marketId.toString());

export const getMarketHcp = (marketId, specifiers, extra) => {
  let hcpOutput = { ...(specifiers || {}) };
  const scoreDelimiter = ':';

  if (specifiers && specifiers.hcp) {
    hcpOutput = { ...specifiers };

    hcpOutput.feedValue = hcpOutput.hcp;
    if (!hcpOutput.hcp.includes(scoreDelimiter)) {
      hcpOutput.hcp = parseFloat(hcpOutput.hcp);
    }
  } else if (isMarketInCollection(handicapMarketsUOF, marketId)) { // check feed one for undefined
    // create hcp obj from extra
    hcpOutput = {
      name: 'HandicapCustom',
      id: 9999,
      value: extra, // of type 0:2
      feedValue: extra,
    };
  }

  return hcpOutput;
};

export const getMarketExtra = (specifiers, marketId) => {
  if (!specifiers) return '';

  let extraOutput = '';

  if (isMarketInCollection(totalMarketsUOF, marketId)) {
    extraOutput = specifiers.total || '';
  } else if (isMarketInCollection(winTennisSetUOF, marketId)) {
    extraOutput = specifiers.setnr || '';
  } else if (isMarketInCollection(restOfTheMatchMarketsUOF, marketId)) {
    extraOutput = specifiers.score || '';
  } else if (isMarketInCollection(nextGoalUOF, marketId)) {
    extraOutput = specifiers.score || '';
    // current score home:away
  } else if (isMarketInCollection(asianHandicapMarketsUOF, marketId)) {
    extraOutput = specifiers.hcp || '';
  } else if (isMarketInCollection(handicapMarketsUOF, marketId)) {
    extraOutput = specifiers.hcp || '';
  } else if (isMarketInCollection(winGamesUOF, marketId)) {
    const gamenrX = specifiers.gamenrX || '';
    const gamenrY = specifiers.gamenrY || '';
    const setnr = specifiers.setnr || '';
    extraOutput = gamenrX + '-' + gamenrY + 'and' + setnr;
  } else if (isMarketInCollection(raceToPointsUOF, marketId)) {
    extraOutput = specifiers.pointnr || '';
  } else if (isMarketInCollection(whoScoresPointUOF, marketId)) {
    extraOutput = specifiers.pointnr || '';
  } else if (isMarketInCollection(winTennisGameUOF, marketId)) {
    extraOutput = specifiers.gamenr || '';
  }

  return extraOutput;
};
